export default __webpack_public_path__ + "static/media/exam.2852ee09.svg";